import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    q: "Who is Anchor coaching for?",
    a: "Anchor is for people moving through transition, intensity, or quiet dissatisfaction — and who sense the answer is not more effort, but a deeper kind of presence. It is not therapy. It is structured, reflective work on how you meet your own life.",
  },
  {
    q: "What does the coaching look like in practice?",
    a: "We meet weekly (60 minutes), with between-session practices tailored to where you are. Most clients commit to a 12-week container. The work is direct, calm, and intentional — no scripts, no jargon.",
  },
  {
    q: "How is this different from a course or app?",
    a: "Courses give you information. Anchor builds a felt practice through real reflection with another human paying close attention. The 28-day program is a gentle introduction. Coaching is the deeper work.",
  },
  {
    q: "Is the 28-day program really free?",
    a: "Yes. It exists because the practices in it should be available to anyone willing to sit with them. There is no upsell required — many people use it on their own and never apply for coaching.",
  },
  {
    q: "How do I know if I'm a fit?",
    a: "The application is the conversation. There is no obligation. If we are not a fit, you will leave with a clearer picture of what is.",
  },
];

export default function FAQ() {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative py-24 md:py-40"
      style={{ backgroundColor: "#F7F5F0" }}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 md:grid-cols-12 gap-12 items-start">
        <div className="md:col-span-4">
          <p className="overline mb-6">08 — Honest answers</p>
          <h2
            className="serif text-4xl md:text-5xl text-[#15243D] leading-[1.1]"
            style={{ fontWeight: 300 }}
          >
            Questions,<br />
            <em className="italic text-[#C07865]">honestly</em> answered.
          </h2>
        </div>

        <div className="md:col-span-7 md:col-start-6">
          <Accordion
            type="single"
            collapsible
            className="w-full"
            data-testid="faq-accordion"
          >
            {faqs.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="border-b border-[#15243D]/10"
              >
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="text-left text-lg md:text-xl py-6 font-light text-[#15243D] hover:no-underline hover:text-[#C07865] transition-colors"
                  style={{ fontFamily: "Spectral, serif" }}
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent
                  className="text-base font-light leading-relaxed text-[#5A5D63] pb-6 pr-6"
                >
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
